import * as React from 'react';

import type { GlobalMarketDataShape } from '@blockworks/platform/api/research';
import type { PostType } from '@blockworks/platform/api/strapi';

import RightColumnWithMarketsData from '@/components/layouts/right-column-with-markets-data';
import { prepareGlobalMarketData } from '@/components/pages/prices/utils/prepare-global-market-data';

type TokenTransparencyRightRailProps = {
    recentResearch: PostType;
    globalMarketHistory: GlobalMarketDataShape[];
};

export const TokenTransparencyRightRail = (props: TokenTransparencyRightRailProps) => {
    const { globalMarketHistory, recentResearch } = props;

    const { globalMarketData, globalMarketChange, globalMarketVolumeChange } =
        prepareGlobalMarketData(globalMarketHistory);

    return (
        <RightColumnWithMarketsData
            globalMarketHistory={globalMarketHistory}
            currentGlobalMarketVolumeChange={globalMarketVolumeChange}
            currentGlobalMarketChange={globalMarketChange}
            currentGlobalMarketData={globalMarketData}
            recentResearch={recentResearch}
            className="w-full xl:w-72 h-full border-t md:border-t-0"
            showNewsletter={false}
        />
    );
};
